import { useEffect, useState } from 'react';
import { fetchRegistrationExamPaperOptions } from 'src/app/modules/Recruitment/network/license-exam-crud';
import { ExamPaperApiItem, ExamPaperApiResponse } from 'src/app/modules/Recruitment/types/license-exam-types';
import { getConfig } from 'src/app/i18n/I18nConfig';
import { RegionLocale } from 'src/app/i18n';

export const getExamPaperTitle = (item: ExamPaperApiItem, lang: string): string => {
  const enName = item.examName?.en;
  const zhHantName = item.examName?.['zh-Hant'];

  if (lang === RegionLocale.ENGLISH) {
    return enName || zhHantName || item.examCode;
  }

  return zhHantName || enName || item.examCode;
};

type ExamPaperType = 'F' | 'S';

export const ExamPaperType = {
  F: 'F',
  S: 'S',
} as const;

export type ExamPaperSelectionItem = ExamPaperApiItem & {
  paperType: ExamPaperType;
  value: string;
  localized: string;
};

const mapExamPaperSelectionItem = (
  item: ExamPaperApiItem,
  lang: string,
  paperType: ExamPaperType,
): ExamPaperSelectionItem => ({
  ...item,
  paperType,
  value: `${paperType}_${item.examCode}`,
  localized: getExamPaperTitle(item, lang),
});

export const useExamPaperSelection = () => {
  const [paperList, setPaperList] = useState<ExamPaperSelectionItem[]>([]);
  const [loading, setLoading] = useState(false);
  const lang = getConfig().selectedLang;

  useEffect(() => {
    let active = true;

    const loadPaperList = async () => {
      setLoading(true);
      try {
        const response = await fetchRegistrationExamPaperOptions();
        const responseData: ExamPaperApiResponse = response && typeof response === 'object' ? response : {};
        const responseList: ExamPaperSelectionItem[] = [
          ...(responseData.F || []).map((item) => mapExamPaperSelectionItem(item, lang, ExamPaperType.F)),
          ...(responseData.S || []).map((item) => mapExamPaperSelectionItem(item, lang, ExamPaperType.S)),
        ];
        if (active) {
          setPaperList(responseList);
        }
      } finally {
        if (active) {
          setLoading(false);
        }
      }
    };

    loadPaperList();

    return () => {
      active = false;
    };
  }, [lang]);

  return {
    paperList,
    loading,
  };
};
